module.exports = __webpack_public_path__ + "img/Windows_1.107cc893.png";